import { of, from, Observable, concat } from "rxjs";
import {
  mergeMap,
  withLatestFrom,
  map,
  debounceTime,
  catchError,
} from "rxjs/operators";
import { combineEpics, ofType } from "redux-observable";
import {
  settingsSetAppSettings,
  settingsSetLanguage,
  settingsBackupSaved,
  settingsBackupNextStep,
  settingsBackupRestored,
  settingsRestoreNextStep,
  settingsBackupDropboxProgress,
  // settingsAndroidBackupSaved,
  types,
} from "./settings.redux";
import { updateSharedSettings } from "../login/userSession.redux";

// import { types as spectreAppTypes } from '../spectreApp/spectreApp.redux';
// import { fileSystem } from '../fileSystem/fileSystem';
import * as R from "ramda";
import { getDatabaseName } from "../../utils.js";
import { getAppConfig } from "../../appConfig";

// const settingsSaveBackupEpic = (action$, state$) =>
//   action$.pipe(
//     ofType(types.settingsSaveBackup),
//     withLatestFrom(state$),
//     mergeMap(([, state]) => {
//       console.log('Preparing backup');
//       const { prepareBackup } = fileSystem();
//       console.log(state);
//       const databaseName = getDatabaseName(state.spectreApp.databaseName, getAppConfig().databaseVersion);

//       return from(prepareBackup(databaseName)).pipe(
//         map(backupInfo => settingsBackupNextStep({ backupInfo })),
//         catchError(_ => of(settingsBackupSaved()))
//       );
//     })
//   );

// const settingsBackupStepsEpic = (action$, state$) =>
//   action$.pipe(
//     ofType(types.settingsBackupNextStep),
//     withLatestFrom(state$),
//     mergeMap(([{ payload }, state]) => {
//       const backupStep = state.settings.backupStep;
//       const backupInfo = payload.backupInfo;
//       console.log('Generating backup step', backupStep);

//       switch (backupStep) {
//         case 2:
//           const { zipBackup } = fileSystem();
//           return from(zipBackup(backupInfo)).pipe(
//             map(backupFile => settingsBackupNextStep({ backupFile })),
//             catchError(_ => of(settingsBackupSaved()))
//           );
//         case 3:
//           const { saveFileToDropbox, DROPBOX_APP_KEY } = fileSystem();
//           const { backupFile } = payload;
//           return Observable.create(backupProgressObserver => {
//             saveFileToDropbox(backupFile, DROPBOX_APP_KEY)
//               .then(_ => backupProgressObserver.next(settingsBackupSaved()))
//               .catch(_ => backupProgressObserver.next(settingsBackupSaved()));
//           });
//       }
//     })
//   );

// const settingsAndroidBackupEpic = (action$, state$) =>
//   action$.pipe(
//     ofType(types.settingsAndroidBackup),
//     withLatestFrom(state$),
//     mergeMap(() => {
//       console.log('Preparing backup');
//       const { copyAndroidDB } = fileSystem();

//       return from(copyAndroidDB()).pipe(
//         map(_ => settingsAndroidBackupSaved({})),
//         catchError(_ => of(settingsAndroidBackupSaved()))
//       );
//     })
//   );

// const settingsRestoreBackupEpic = (action$, state$) =>
//   action$.pipe(
//     ofType(types.settingsRestoreBackup),
//     mergeMap(() => {
//       const { chooseFile, cacheRestoreFile } = fileSystem();

//       const prepareRestore = R.pipeP(
//         chooseFile,
//         restoreFileUrl => cacheRestoreFile(restoreFileUrl)
//       );

//       return from(prepareRestore(['zip'])).pipe(
//         map(restoreFileCache => settingsRestoreNextStep({ restoreFileCache })),
//         catchError(_ => of(settingsBackupRestored()))
//       );
//     })
//   );

// const settingsRestoreStepsEpic = (action$, state$) =>
//   action$.pipe(
//     ofType(types.settingsRestoreNextStep),
//     withLatestFrom(state$),
//     mergeMap(([{ payload }, state]) => {
//       const restoreStep = state.settings.restoreStep;
//       const restoreFileCache = payload.restoreFileCache;
//       const restoreFile = payload.restoreFile;

//       switch (restoreStep) {
//         case 2:
//           const { unzipRestore } = fileSystem();
//           return from(unzipRestore(restoreFileCache.url)).pipe(
//             map(
//               restoreFile => settingsRestoreNextStep({ restoreFile, restoreFileCache }),
//               catchError(_ => of(settingsBackupRestored()))
//             )
//           );
//         case 3:
//           const { restoreData } = fileSystem();
//           return from(restoreData(restoreFile)).pipe(
//             map(
//               () => settingsRestoreNextStep({ restoreFile, restoreFileCache }),
//               catchError(_ => of(settingsBackupRestored()))
//             )
//           );
//         case 4:
//           const { restoreImages } = fileSystem();
//           return from(restoreImages(restoreFile)).pipe(
//             map(
//               () => settingsRestoreNextStep({ restoreFile, restoreFileCache }),
//               catchError(_ => of(settingsBackupRestored()))
//             )
//           );
//         case 5:
//           const { removeFile } = fileSystem();
//           return from(removeFile(restoreFileCache.url)).pipe(
//             map(() => {
//               setTimeout(() => {
//                 location.reload();
//               }, 500);
//               return settingsBackupRestored();
//             })
//           );
//       }
//     })
//   );

const settingsChangeLanguageEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.settingsChangeLanguage),
    withLatestFrom(state$),
    mergeMap(
      ([
        {
          payload: { language },
        },
        state,
      ]) => {
        const shared_settings = {
          plugin_settings: state.plugin.plugin_settings,
          appSettings: state.settings.appSettings,
          language,
        };
        return concat(
          of(updateSharedSettings({ shared_settings })),
          of(settingsSetLanguage({ language }))
        );
      }
    )
  );

const settingsHandleFormEpic = (action$, state$) =>
  action$.pipe(
    ofType(types.settingsHandleForm),
    withLatestFrom(state$),
    debounceTime(500),
    mergeMap(
      ([
        {
          payload: { appSettings },
        },
        state,
      ]) => {
        const shared_settings = {
          plugin_settings: state.plugin.plugin_settings,
          appSettings,
          language: state.settings.language,
        };

        return concat(
          of(updateSharedSettings({ shared_settings })),
          of(settingsSetAppSettings({ appSettings: appSettings }))
        );
      }
    )
  );

// const settingsEpic = action$ =>
//   action$.pipe(
//     ofType(spectreAppTypes.spectreappApplicationStart),
//     mergeMap(() => {
//       const savedSettings = window.localStorage.getItem('spectre_user_settings');
//       return of(settingsSetAppSettings({ appSettings: JSON.parse(savedSettings) }));
//     })
//   );

export default combineEpics(
  // settingsEpic,
  settingsHandleFormEpic,
  settingsChangeLanguageEpic
  // settingsSaveBackupEpic,
  // settingsBackupStepsEpic,
  // settingsRestoreBackupEpic,
  // settingsRestoreStepsEpic,
  // settingsAndroidBackupEpic
);
